import { Injectable, EventEmitter } from '@angular/core';
import { Subscription } from 'rxjs/internal/Subscription';

@Injectable()
export class EventEmitterService {

  invokeClearMemberSearch = new EventEmitter();
  memberSearchSubsVar: Subscription;

  invokeClearMerchantAccountSearch = new EventEmitter();
  merchantAccountSubsVar: Subscription;

  updateSelectedReceipt = new EventEmitter();
  selectedReceiptSubsVar: Subscription;

  updateRewardSettings = new EventEmitter();
  updateRewardSettingsVar: Subscription;

  openNotificationMenu = new EventEmitter();
  openNotificationMenuVar: Subscription;

  listenNotificationWebsocket = new EventEmitter();
  listenNotificationWebsocketVar: Subscription;

  detectIdenticalSettings = new EventEmitter();
  detectIdenticalSettingsVar: Subscription;

  updateTimezone = new EventEmitter();
  callUpdateTimezone: Subscription;

  notificationRedirect = new EventEmitter();
  listenNotificationRedirect: Subscription;

  addTransaction = new EventEmitter();
  addTransactionCrypto = new EventEmitter();

  memberInformationChangeTab = new EventEmitter();
  memberInformationChangeTabVar: Subscription;

  withdrawalUpdate = new EventEmitter();
  withdrawalUpdateEmmiter: Subscription;
  
  updateDepositTabBadge = new EventEmitter();

  updateAffiliateMessageTemplateTabCount = new EventEmitter();
  updateAffiliateMessageTemplateTabCountVar: Subscription;

  basicSettingData = new EventEmitter();
  basicSettingDataEmmiter: Subscription;

  providerBlacklistData = new EventEmitter();
  providerBlacklistDataEmmiter: Subscription;

  saveBlacklistPreset = new EventEmitter();
  saveBlacklistPresetEmmiter: Subscription;

  basicSettingSave = new EventEmitter();
  basicSettingSaveEmmiter: Subscription;

  eligibilitySettingData = new EventEmitter();
  eligibilitySettingDataEmmiter: Subscription;

  eligibilitySettingSave = new EventEmitter();
  eligibilitySettingSaveEmmiter: Subscription;

  memberSettingData = new EventEmitter();
  memberSettingDataEmmiter: Subscription;

  memberSettingSave = new EventEmitter();
  memberSettingSaveEmmiter: Subscription;

  kycSettingData = new EventEmitter();
  kycSettingDataEmmiter: Subscription;

  kycSettingSave = new EventEmitter();
  kycSettingSaveEmmiter: Subscription;

  messageSettingData = new EventEmitter();
  messageSettingDataEmmiter: Subscription;

  messageSettingSave = new EventEmitter();
  messageSettingSaveEmmiter: Subscription;

  promotionNameSettingData = new EventEmitter();
  promotionNameSettingDataEmmiter: Subscription;

  promotionNameSettingSave = new EventEmitter();
  promotionNameSettingSaveEmmiter: Subscription;

  promotionCurrencySettingData = new EventEmitter();
  promotionCurrencySettingDataEmmiter: Subscription;

  promotionCurrencySettingSave = new EventEmitter();
  promotionCurrencySettingSaveEmmiter: Subscription;

  refreshWithdrawal = new EventEmitter();
  refreshWithdrawalEmmiter: Subscription;

  refreshWithdrawDialog = new EventEmitter();
  refreshWithdrawDialogEmmiter: Subscription;

  constructor() { }

  onListenNotificationWebsocket() {
    this.listenNotificationWebsocket.emit();
  }

  onOpenNotificationMenu() {
    this.openNotificationMenu.emit();
  }

  onClearMemberSearch() {
    this.invokeClearMemberSearch.emit();
  }

  onClearMerchantAccountSearch() {
    this.invokeClearMerchantAccountSearch.emit();
  }

  onUpdateSelectedReceipt(data: any) {
    this.updateSelectedReceipt.emit(data);
  }

  onUpdateRewardSettings(data: any) {
    this.updateRewardSettings.emit(data);
  }

  onDetectIdenticalSettings(data: any) {
    this.detectIdenticalSettings.emit(data);
  }

  onUpdateTimezone() {
    this.updateTimezone.emit();
  }

  onNotificationRedirect(data: any) {
    this.notificationRedirect.emit(data);
  }

  onAddTransaction(withdraw: any, action: any, is_crypto: boolean) {
    if( is_crypto ) {
      this.addTransactionCrypto.emit({withdraw, action});
    } else {
      this.addTransaction.emit({withdraw, action});
    }
  }

  onUpdateWithdrawal(withdrawal: any) {
    this.withdrawalUpdate.emit(withdrawal);
  }

  onUpdateDepositResult(data: any) {
    this.updateDepositTabBadge.emit(data);
  }

  onUpdateAffiliateMessageTemplateTabCount() {
    this.updateAffiliateMessageTemplateTabCount.emit();
  }

  onBasicSettingData(form = null) {
    this.basicSettingData.emit(form);
  }

  onBasicSettingSave() {
    this.basicSettingSave.emit();
  }

  onEligibilitySettingData(form = null) {
    this.eligibilitySettingData.emit(form);
  }

  onEligibilitySettingSave() {
    this.eligibilitySettingSave.emit();
  }

  onMemberSettingData(form = null) {
    this.memberSettingData.emit(form);
  }

  onMemberSettingSave() {
    this.memberSettingSave.emit();
  }

  onKYCSettingData(form = null) {
    this.kycSettingData.emit(form);
  }

  onKYCSettingSave() {
    this.kycSettingSave.emit();
  }

  onMessageSettingData(form = null) {
    this.messageSettingData.emit(form);
  }

  onMessageSettingSave() {
    this.messageSettingSave.emit();
  }

  onPromotionNameSettingData(form = null) {
    this.promotionNameSettingData.emit(form);
  }

  onPromotionNameSettingSave() {
    this.promotionNameSettingSave.emit();
  }

  onPromotionCurrencySettingData(form = null) {
    this.promotionCurrencySettingData.emit(form);
  }

  onProviderBlacklistData(data = null) {
    this.providerBlacklistData.emit(data);
  }

  onSaveBlacklistPreset() {
    this.saveBlacklistPreset.emit();
  }

  onPromotionCurrencySettingSave() {
    this.promotionCurrencySettingSave.emit();
  }

  onRefreshWithdrawal() {
    this.refreshWithdrawal.emit();
  }

  onRefreshWithdrawDialog(bankTransactions: any, withdrawalStatus: any) {
    this.refreshWithdrawDialog.emit({bankTransactions, withdrawalStatus});
  }
}
